export type ProposalStatus = 'OWNER'|'AGENT'
    |'AUTO_COMPLETE'|'MANUAL'|'NO_RESPONSE'
    |'AUTO_INITIAL' |'AUTO_INCOMPLETE'
    |'AUTO_ERROR'|'DELETED'|'REJECTED'|'SOLD';
export const SOURCE_RELAPKA = 'relapka' as const;
export const SOURCE_GEORGIA_BATUMI_KORTER = 'georgia_batumi_korter' as const;
export const SOURCE_GEORGIA_BATUMI_MYHOME = 'georgia_batumi_myhome' as const;
export const SOURCE_BELARUS_MINSK_ONLINER = 'belarus_minsk_onliner' as const;

export type Source =
    | typeof SOURCE_RELAPKA
    | typeof SOURCE_GEORGIA_BATUMI_KORTER
    | typeof SOURCE_GEORGIA_BATUMI_MYHOME
    | typeof SOURCE_BELARUS_MINSK_ONLINER;

export interface Proposal {
    id: string;
    proposalStatus: ProposalStatus
    createdAt:number
    adminCheckDate:number
    createdAtExternal: string
    type: string
    description: string
    rejectedReason: string
    externalId: string;
    source: Source
    editId: string
    link: string;
    samePhones: number;
    phone: string;
    name: string;
    price: number;
    area: number;
    address: string;
    floor: number;
    floorMax: number;
    rooms: string;
    windows: string;
    view: string;
    heating: string;
    cadastralCode: string;
    adminNotes: string;
    whatsapp: string;
    createdBy: string;
    updatedBy: string;
    favorite: boolean;
    maps: string;
    lat:number,
    lng:number,
    resources: ProposalResource[];
    renovationStatus: 'RENOVATED' | 'RENOVATED_FURNISHED' | 'NEEDS_RENOVATION'
}

export interface ProposalResource {
    id:string
    type: 'image'
    source: Source
    content:string
}